import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
   selector: '[samwebVar]',
})
export class NgVarDirective {
   @Input()
   set samwebVar(context: unknown) {
      this.context.$implicit = this.context.samwebVar = context;

      if (!this.hasView) {
         this.vcRef.createEmbeddedView(this.templateRef, this.context);
         this.hasView = true;
      }
   }

   private context: {
      $implicit: unknown;
      samwebVar: unknown;
   } = {
      $implicit: null,
      samwebVar: null,
   };

   private hasView = false;

   constructor(private templateRef: TemplateRef<any>, private vcRef: ViewContainerRef) {}
}
